<template>
  <div class="home">
     <div class="relative max-w-5xl mx-auto">
      <div class="flex flex-col min-h-screen lg:flex-row lg:items-center lg:p-8">
        <div class="flex flex-col flex-grow bg-white lg:shadow-2xl lg:rounded-lg lg:overflow-hidden">
          <div class="flex-grow flex flex-col justify-center p-12">
            <div class="flex items-center">
              <img class="m-1" alt="COATIEMU" src="../assets/logo-caat.png">
            </div>
            <div class="md:pl-16 pl-0">
              <h1 class="sm:font-light text-2xl sm:text-3xl md:text-4xl text-gray-900 mt-6">Verificador de documentos telemáticos</h1>
              <div v-if="mostrarFormulario">
                <p class="sm:text-xl text-gray-600 mt-3 leading-relaxed">El Colegio Oficial de Aparejadores, Arquitectos Técnicos e Ingenieros de Edificación de la Región de Murcia pone a su disposición este servicio que le permite verificar la validez de cualquier documento técnico (proyecto, certificado, etc.) en el que aparece el sello de la intervención colegial.
                <br />Para ello únicamente deberá introducir el Código seguro de verificación (CSV) que figura en el sello y comprobar que los datos que se muestran coinciden con los de su documento.</p>
                <div class="py-6">
                  <input class="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" v-model="codigo" type="text" placeholder="Código CSV">
                  <button @click="verificar" class="ml-6 bg-transparent hover:bg-murcia text-murcia font-semibold hover:text-white py-2 px-4 border border-murcia hover:border-transparent rounded"> verificar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-100 border-t-2 border-gray-200" v-if="mostrarDatos">
            <div class="flex flex-wrap">
              <div class="flex flex-col px-12 py-10 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-gray-800 text-lg">Datos identificativos de la intervención profesional</h2>
                    <p class="text-gray-600 mt-1 text-sm md:text-base">Número de Expediente</p>
                    <p class="text-black mt-0 text-sm md:text-base">{{ validacion.NumeroExpediente }}</p>
                    <p class="text-gray-600 mt-1 text-sm md:text-base">Número de Intervención</p>
                    <p class="text-black mt-0 text-sm md:text-base">{{ validacion.NumeroVisado }}</p>
                    <p class="text-gray-600 mt-1 text-sm md:text-base">Tipo de intervención</p>
                    <p class="text-black mt-0 text-sm md:text-base">{{ validacion.Objeto }}</p>
                    <p class="text-gray-600 mt-3 text-sm md:text-base">Descripción</p>
                    <p class="text-black mt-0 text-sm md:text-base">{{ validacion.Descripcion }}</p>
                    <p class="text-gray-600 mt-3 text-sm md:text-base">Emplazamiento</p>
                    <p class="text-black mt-0 text-sm md:text-base">{{ validacion.Emplazamiento }}</p>
                    <p class="text-gray-600 mt-3 text-sm md:text-base">Promotor</p>
                    <p class="text-black mt-0 text-sm md:text-base">{{ validacion.Promotores }}</p>
                    <p v-if="descarga" class="text-gray-600 mt-3 text-sm md:text-base">Técnicos autores</p>
                    <p v-if="descarga" class="text-black-600 mt-0 text-sm md:text-base">{{ validacion.Tecnicos }}</p>
                  </div>
                </div>
              </div>
              <div class="flex flex-col px-12 py-6 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-gray-800 text-lg">Datos identificativos del documento</h2>
                    <p class="text-gray-600 mt-1 text-sm md:text-base">Descripción</p>
                    <p class="text-black mt-0 text-sm md:text-base">{{ validacion.DescripcionDocumento }}</p>                    
                    <p v-if="descarga == false" class="text-gray-600 mt-3 text-sm md:text-base">Técnicos autores</p>
                    <p v-if="descarga == false" class="text-black mt-0 text-sm md:text-base">{{ validacion.Tecnicos }}</p>
                  </div>
                </div>
              </div>
              <div class="flex flex-col px-12 py-6 w-full sm:border-r sm:border-b border-gray-200">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-gray-800 text-lg">Intervención colegial realizada</h2>
                    <p class="text-black mt-1 text-sm md:text-base">{{ fechaTramite }}</p>
                    <p class="text-black mt-1 text-sm md:text-base">{{ validacion.TipoTramite }}</p>
                    <p class="text-black mt-1 text-sm md:text-base">{{ validacion.VisadoGarantia }}</p>
                  </div>
                </div>
              </div>
              <div v-if="descarga" class="flex flex-col px-12 py-6 w-full sm:border-r sm:border-b border-gray-200">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-gray-800 text-lg">Fichero PDF</h2>
                    <a :href="urlFichero"> Descargar</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-100 border-t-2 border-gray-200" v-if="error">
            <div class="flex flex-wrap">
              <div class="flex flex-col px-12 py-10 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-red-800 text-lg">Error!</h2>
                    <p class="text-red-600 mt-0 text-sm md:text-base">El código introducido no es válido</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-100 border-t-2 border-gray-200" v-if="anulado">
            <div class="flex flex-wrap">
              <div class="flex flex-col px-12 py-10 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-red-800 text-lg">Nota</h2>
                    <p class="text-red-600 mt-0 text-sm md:text-base">Este documento ha sido anulado y existe una nueva versión actualizada del mismo. Para más información debe contactar con el profesional que suscribe el documento.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="error || anulado || validacion != null" class="flex flex-col px-12 py-6 w-full sm:border-r sm:border-b border-gray-200">
            <div class="flex flex-grow">
              <button @click="nuevaVerificacion" class="bg-transparent hover:bg-murcia text-murcia font-semibold hover:text-white py-2 px-4 border border-murcia hover:border-transparent rounded"> verificar otro documento</button>
            </div>
          </div>
          <div class="bg-gray-300 border-t-2 border-gray-200">
            <div class="flex flex-wrap">
              <div class="flex flex-col px-12 py-10 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                   <p class="text-center w-full">© 2020 - Colegio Oficial de Aparejadores, Arquitectos Técnicos e Ingenieros de Edificación de la Región de Murcia</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import validacionTelematicaService from '../services/validacionTelematicaService.js';
import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: "6LdMBdkZAAAAAJExdH9TPZkwwZY4y7N4tQv8GV9n" });

export default {
  name: 'Home',
  data () {
    return {
      validacion: null,
      codigo: '', // Anulado -> 286AE5C80910  Descarga -> EC08B1938BEB  Texto garantia -> FAE7676D9554
      error: false,
      descarga: false,
      anulado: false,
    }
  },
  created() {
    this.loadFromApi()
  },
  computed: {
    fechaTramite() {        
        var info = this.validacion.FechaTramite.substr(0,10).split('-').reverse().join('/');
        return info;
   },
   urlFichero() {
    return 'https://webapi.coaatiemu.es/api/v1/ValidacionTelematica/file?codigo=' + this.codigo + '&file='+ this.codigo +'.pdf'
   },
   mostrarDatos() {
     return !this.anulado && this.validacion != null;
   },
   mostrarFormulario() {
     return this.validacion == null && !this.error && !this.anulado 
   }

  },
  methods: {
    loadFromApi() {
     
    },
    verificar() {
      this.error = false
      
      this.$recaptcha("contactus").then(token => {
        validacionTelematicaService.get(this.codigo)
          .then((validacion) => {              
              this.validacion = validacion.data[0];
              console.log(this.validacion);
              this.anulado = this.validacion.FechaAnulacion != null;
              this.descarga = this.validacion.DescargaIntegra
              if(this.anulado)
                this.validacion = null;
            }
          )
          .catch((error) => {
          // Error 😨
          this.validacion = null
          this.error = true
          if (error.response) {
              /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
          } else if (error.request) {
              /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
              console.log(error.request);
          } else {
              // Something happened in setting up the request and triggered an Error
              console.log('Error', error.message);
          }
          });
      
        console.log(token);
      });
    },
    nuevaVerificacion() {
      this.codigo = ""
      this.validacion = null
      this.error = false
      this.anulado = false
    }
  }
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  padding: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #4d4d4d;
  text-decoration: underline;
}
.pendiente {
  color: #ff0000;
}
</style>
